<template>
  <div :class="containerClass">
    <div class="layout-config-content-wrapper">
      <a href="#" class="layout-config-button" style="top: 50%" @click="toggleConfigurator"
        v-show="$route.name === 'setting'">
        <i class="pi pi-palette"></i>
      </a>
      <a href="#" class="layout-config-close" @click="hideConfigurator">
        <i class="pi pi-times"></i>
      </a>
      <div class="layout-config-content">
        <h5>Масштаб компонентов</h5>
        <div class="config-scale">
          <Button icon="pi pi-minus" @click="decrementScale" class="p-button-text" :disabled="scale === scales[0]" />
          <i class="pi pi-circle-on" v-for="s of scales" :class="{ 'scale-active': s === scale }" :key="s" />
          <Button icon="pi pi-plus" @click="incrementScale" class="p-button-text"
            :disabled="scale === scales[scales.length - 1]" />
        </div>
        <h5>Цвет верхней панели</h5>
        <div class="col-5 flex flex-column align-items-center gap-2">
          <ColorPicker v-model="topbarColor" @click="applyTopbarColor" inline />
          <Button label="Цвет по умолчанию" class="p-button-sm" @click="topbarDefault" />
        </div>
        <AppInputStyleSwitch />
        <h5>Эффект ряби</h5>
        <InputSwitch :modelValue="rippleActive" @update:modelValue="onRippleChange" />

        <h5>Бутстрап</h5>
        <div class="grid free-themes text-center">
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'bootstrap4-light-blue')">
              <img src="images/themes/bootstrap4-light-blue.svg" alt="Bootstrap Light Blue" />
            </button>
            <span>Синий</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'bootstrap4-light-purple')">
              <img src="images/themes/bootstrap4-light-purple.svg" alt="Bootstrap Light Blue" />
            </button>
            <span>Фиолетовый</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'bootstrap4-dark-blue', true)">
              <img src="images/themes/bootstrap4-dark-blue.svg" alt="Bootstrap Dark Blue" />
            </button>
            <span>Синий</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'bootstrap4-dark-purple', true)">
              <img src="images/themes/bootstrap4-dark-purple.svg" alt="Bootstrap Dark Blue" />
            </button>
            <span>Фиолетовый</span>
          </div>
        </div>

        <h5>PrimeOne Дизайн</h5>
        <div class="grid free-themes text-center">
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'saga-blue')">
              <img src="images/themes/saga-blue.png" alt="Saga Blue" />
            </button>
            <span>Синяя история</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'saga-green')">
              <img src="images/themes/saga-green.png" alt="Saga Green" />
            </button>
            <span>Зеленая история</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'saga-orange')">
              <img src="images/themes/saga-orange.png" alt="Saga Orange" />
            </button>
            <span>Оранжевая история</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'saga-purple')">
              <img src="images/themes/saga-purple.png" alt="Saga Purple" />
            </button>
            <span>Фиолетовая история</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'vela-blue', true)">
              <img src="images/themes/vela-blue.png" alt="Vela Blue" />
            </button>
            <span>Синяя свеча</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'vela-green', true)">
              <img src="images/themes/vela-green.png" alt="Vela Green" />
            </button>
            <span>Зеленая свеча</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'vela-orange', true)">
              <img src="images/themes/vela-orange.png" alt="Vela Orange" />
            </button>
            <span>Оранжевая свеча</span>
          </div>
          <div class="col-3 flex flex-column align-items-center">
            <button class="p-link" type="button" @click="changeTheme($event, 'vela-purple', true)">
              <img src="images/themes/vela-purple.png" alt="Vela Purple" />
            </button>
            <span>Фиолетовая свеча</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, watch, onMounted, onUnmounted, getCurrentInstance, defineEmits, defineProps } from 'vue';
import { useRoute } from 'vue-router';
import EventBus from '../EventBus';

const props = defineProps({
  theme: String,
  inputStyle: String,
});

const emit = defineEmits(['change-theme', 'change-color']);

const route = useRoute();
const instance = getCurrentInstance();
const primevueConfig = instance.proxy.$primevue.config;

const active = ref(false);
const scale = ref(13);
const scales = [12, 13, 14, 15];
const topbarColor = ref('84abd6');
let outsideClickListener = null;

const containerClass = computed(() => {
  return ['layout-config', { 'layout-config-active': active.value }];
});

const rippleActive = computed(() => primevueConfig.ripple);

function toggleConfigurator(event) {
  active.value = !active.value;
  event.preventDefault();
  if (active.value) bindOutsideClickListener();
  else unbindOutsideClickListener();
}

function hideConfigurator(event) {
  active.value = false;
  unbindOutsideClickListener();
  event.preventDefault();
}

function changeTheme(event, theme, dark) {
  emit('change-theme', { theme, dark });
  event.preventDefault();
}

function bindOutsideClickListener() {
  if (!outsideClickListener) {
    outsideClickListener = (event) => {
      if (active.value && isOutsideClicked(event)) {
        active.value = false;
      }
    };
    document.addEventListener('click', outsideClickListener);
  }
}

function unbindOutsideClickListener() {
  if (outsideClickListener) {
    document.removeEventListener('click', outsideClickListener);
    outsideClickListener = null;
  }
}

function isOutsideClicked(event) {
  const el = instance.proxy.$el;
  return !(el.isSameNode(event.target) || el.contains(event.target));
}

function decrementScale() {
  scale.value--;
  applyScale();
}

function incrementScale() {
  scale.value++;
  applyScale();
}

function applyScale() {
  localStorage.scale = scale.value;
  document.documentElement.style.fontSize = scale.value + 'px';
}

function applyTopbarColor(event) {
  localStorage.topbarColor = topbarColor.value;
  emit('change-color');
  if (event) event.preventDefault();
}

function onRippleChange(value) {
  primevueConfig.ripple = value;
}

function topbarDefault() {
  topbarColor.value = '84abd6';
  localStorage.removeItem('topbarColor');
  emit('change-color');
}

watch(
  () => route,
  () => {
    if (active.value) {
      active.value = false;
      unbindOutsideClickListener();
    }
  },
  { deep: true }
);

onMounted(() => {
  if (localStorage.scale && Number(localStorage.scale) !== scale.value) {
    scale.value = Number(localStorage.scale);
    applyScale();
  }
  if (localStorage.topbarColor && localStorage.topbarColor !== topbarColor.value) {
    topbarColor.value = localStorage.topbarColor;
  }

  EventBus.on('change-theme', (event) => {
    if (event.theme === 'nano') {
      scale.value = 12;
    } else {
      scale.value = 13;
    }
    applyScale();
  });
});

onUnmounted(() => {
  unbindOutsideClickListener();
  EventBus.off('change-theme');
});
</script>
